module.exports = __webpack_public_path__ + "img/Asset15.021f664e.svg";